var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientPrescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19",
    stroke: "#5751E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V11.5M9 9H10M9 13H11.5M9 17H10",
    stroke: "#5751E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1213 21.3793L20.8793 17.6213C21.2772 17.2235 21.5007 16.6839 21.5007 16.1213C21.5007 15.5587 21.2772 15.0191 20.8793 14.6213C20.4815 14.2235 19.942 14 19.3793 14C18.8167 14 18.2772 14.2235 17.8793 14.6213L14.1203 18.3803C13.9234 18.5773 13.7671 18.8112 13.6605 19.0685C13.5539 19.3259 13.499 19.6017 13.499 19.8803C13.499 20.4429 13.7225 20.9825 14.1203 21.3803C14.5182 21.7781 15.0577 22.0016 15.6203 22.0016C16.183 22.0016 16.7225 21.7781 17.1203 21.3803M16.0003 16.5003L19.0003 19.5003",
    stroke: "#5751E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientPrescription);
export default __webpack_public_path__ + "static/media/patient_prescription.ee5575dc91a66c9e9e7a029d748f7370.svg";
export { ForwardRef as ReactComponent };